import type React from "react";
import { motion, type MotionProps } from "motion/react";

export const MOTION_PROP_KEYS: Set<string> = new Set(
  Object.keys({} as MotionProps),
);

type MotionPropKeys = keyof MotionProps;

type SplitMotionProps<T> = {
  motionProps: Pick<T, Extract<keyof T, MotionPropKeys>>;
  domProps: Omit<T, MotionPropKeys>;
};

export function splitMotionProps<T extends Record<string, unknown>>(
  allProps: T,
): SplitMotionProps<T> {
  const motionProps = {} as Pick<T, Extract<keyof T, MotionPropKeys>>;
  const domProps = {} as Omit<T, MotionPropKeys>;

  for (const key of Object.keys(allProps) as Array<keyof T>) {
    if ((MOTION_PROP_KEYS as Set<string>).has(key as string)) {
      (motionProps as typeof motionProps & Record<typeof key, T[typeof key]>)[
        key
      ] = allProps[key];
    } else {
      (domProps as typeof domProps & Record<typeof key, T[typeof key]>)[key] =
        allProps[key];
    }
  }

  return { motionProps, domProps };
}

export function createMotionComponent(as: React.ElementType = "div") {
  const motionTag = motion.create(as);

  return motionTag;
}
